const crc = require('crc');
const AWS = require('aws-sdk');
const saveAs = require('file-saver');
const axios = require('axios').default;

console.log(location.host);
const server_config = require('../config/config');
const cdn_config_map = require('../config/cdn_config.json');
const { s3_info } = require('../config/s3_day7.json');

// const s3_source = new AWS.S3({
//     //accessKeyId:"AKIAQJXQ7J4NSOXJUYE5",
//     accessKeyId:"AKIAYM7POHLJJO4T3GG4", // 스냅퀴즌 s3  1
//     secretAccessKey: "bbkgHqDQPRfsvdGOD6iQp+E1EKGMwWmPNBYs9hSO",    
//     region :"ap-northeast-2",
// });


const s3_source = new AWS.S3({
    accessKeyId:"AKIAYM7POHLJNNWC74Y3", // 스냅퀴즌 s3  2
    secretAccessKey: "Uy9y6S9Lk3Qy+Y1niTKew2UYpE9UGtcVTop4lnAa",    //
    region :"ap-northeast-2",
});



//--> AKIAYM7POHLJNNWC74Y3
//--> Uy9y6S9Lk3Qy+Y1niTKew2UYpE9UGtcVTop4lnAa

//https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/pycho_data/
//https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/pycho_img/
//https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/quiz_data/
//https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/quiz_img/
//https://content-filecenter.s3.ap-northeast-2.amazonaws.com/test_dir/Frame_4.png

console.log(`check server type = ${server_config.default.getServerTypeToString}`);

AWS.config.region = s3_info.region;

async function s3_upload(input_file, key) {
    const param = { Bucket: s3_info.bucket, Key: key, Body: input_file };

    try
    {
        const res = await s3_source.putObject(param).promise();
        console.log(`file uploaded successfully, ${res.Location}`);
    }
    catch (err)
    {
        console.error(err);
    }
}



async function FileUpload_JSON(_inputJson, _fileName) {
  console.log("📂 업로드할 JSON 파일명:", _fileName);

  if (!_fileName) {
      alert("파일 경로(이름)를 입력하세요.");
      return false;
  }

  const formData = new FormData();
  
  // JSON 데이터를 Blob으로 변환하여 파일처럼 추가
  const jsonBlob = new Blob([JSON.stringify(_inputJson)], { type: "application/json" });
  formData.append("file", jsonBlob, _fileName);
  formData.append("filePath", _fileName); // S3 저장 경로 (파일명으로 사용)

  try {
      let backend_server = `${server_config.default.getBackendUrl}/api/s3_upload`;
      console.log("🚀 백엔드 요청 URL:", backend_server);

      const response = await axios.post(backend_server, formData, {
          headers: { "Content-Type": "multipart/form-data" }
      });

      console.log("✅ 업로드 성공:", response.data);
      return true;
  } catch (error) {
      console.error("❌ 업로드 실패:", error);
      return false;
  }
}

async function FileUpload_Async(_inputFile, _filePath)
{
    console.log(_inputFile.name);
    if( !_filePath) {
      alert("  경로를 입력하세요.");
      return;
    }

    const formData = new FormData();
    formData.append("file",_inputFile);
    formData.append("filePath", _filePath); // 경로 전달

    try {
      //const response = await axios.post("http://localhost:3000/upload", formData, {
      //return await axios.post(`${server_config.default.getBackendUrl}/api/upload_file`, fd
      let backend_server  = `${server_config.default.getBackendUrl}/api/s3_upload`;
      console.log(backend_server);
      const response = await axios.post(backend_server, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      console.log("업로드 성공:", response.data);
      return true;
    } catch (error) {
      return false;
    }
}

// 단타의 신 전용 — snap-service 버킷으로 업로드 (별도 엔드포인트)
async function FileUpload_Async_SnapService(_inputFile, _filePath) {
    if (!_filePath) {
        alert("경로를 입력하세요.");
        return false;
    }
    const formData = new FormData();
    formData.append("file", _inputFile);
    formData.append("filePath", _filePath);

    try {
        const backend_server = `${server_config.default.getBackendUrl}/api/s3_upload_snap_service`;
        const response = await axios.post(backend_server, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        console.log("[FileUpload_Async_SnapService] 업로드 성공:", response.data);
        return true;
    } catch (error) {
        console.error("[FileUpload_Async_SnapService] 업로드 실패:", error);
        return false;
    }
}


async function s3_bundle_upload(input_file, key) {
    const param = { Bucket: s3_info.bundleBucket, Key: key, Body: input_file };

    try
    {
        var res = await s3_source.putObject(param).promise();
        console.log(`file uploaded successfully, ${res.Location}`);
    }
    catch (err)
    {
        console.error(err);
    }
    /*
    const s3UploadPromise = new Promise(function (resolve, reject) {
        s3_source.upload(param, function (err, data) {
            if (err) {
                reject(err);
                throw err;
            }

            resolve();
            console.log(`file uploaded successfully, ${data.Location}`)
        });
    });

    await s3UploadPromise;
    */
}

async function sendImageUpload(user_id, file_list, file_infos)
{
    const fd = new FormData();

    for(let x = 0; x < file_list.length; x++ ){
      const file_info = file_list[x];
      fd.append("imageUpload", file_info.file);
    }
    
    fd.append("file_infos", JSON.stringify(file_infos)); 
    fd.append("user_id", user_id);

    return await axios.post(`${server_config.default.getBackendUrl}/resource/imageUpload`, fd,
    {
      headers: {
          'Content-Type': 'multipart/form-data'}
    });
}

async function sendBundleUpload(user_id, osType, file_list)
{
    const fd = new FormData();

    for(let x = 0; x < file_list.length; x++ ){
      const file = file_list[x];
      fd.append(osType, file);
    }
    
    fd.append("os", osType);
    fd.append("user_id", user_id);

    return await axios.post(`${server_config.default.getBackendUrl}/api/upload_file`, fd,
    {
      headers: {'Content-Type': 'multipart/form-data'}
    });
}

function readFileAsync(file) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}
function exportTxt(fileContents, fileName) {
    var blob = new Blob([fileContents], {type: "text/plain;charset=utf-8"});
    saveAs(blob, `${fileName}.txt`);
}

function exportPurgeTxt(purge_list, fileName ) {
    purge_list = purge_list.map((item) => `story/${item}`);
    purge_list = [...new Set(purge_list)];
    exportTxt(purge_list.join("\r\n"), fileName);
}

module.exports = { s3_upload, readFileAsync, exportTxt, exportPurgeTxt, s3_bundle_upload, sendBundleUpload, sendImageUpload ,   FileUpload_Async , FileUpload_JSON, FileUpload_Async_SnapService };